var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAgree = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2012 29.608C19.2012 29.608 21.1179 30.1723 22.9927 27.5606C24.8675 24.9489 26.5651 23.0322 28.0482 21.6377C29.5312 20.2433 30.8371 16.6709 30.8371 15.6262C30.8371 14.5816 33.015 13.0566 34.1902 15.1459C35.3655 17.2352 34.3628 20.2433 33.1456 22.4212C31.9284 24.5992 31.49 26.2967 32.1009 29.3934C32.7119 32.4901 31.6206 36.319 28.0948 37.1025",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7943 23.6006C32.7943 23.6006 39.8971 23.0037 42.0657 25.8625C44.2343 28.7214 41.6553 30.0505 41.6553 30.0505C41.6553 30.0505 44.141 30.5915 43.9918 32.443C43.8425 34.2945 42.4574 34.8168 42.4574 34.8168C42.4574 34.8168 44.0804 35.6936 43.9964 37.2092C43.9125 38.7249 40.3075 39.3592 40.3075 39.3592C40.3075 39.3592 41.6832 40.0961 41.5667 41.5931C41.4501 43.0902 40.1349 43.5938 37.7238 43.5798C35.3127 43.5658 34.4452 44.1208 31.5537 44.0975C28.6623 44.0742 22.245 42.829 19.666 42.9502",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4961 35.8057C30.4961 35.8057 32.744 37.7271 31.2703 42.2789",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4924 26.0215C38.4924 26.0215 34.5282 25.2427 34.5282 27.9569C34.5282 30.2048 36.2165 30.1582 36.2165 30.1582C36.2165 30.1582 34.3184 30.2841 34.3184 32.6626C34.3184 34.7986 36.2351 34.7846 36.2351 34.7846C36.2351 34.7846 34.3184 34.9478 34.3184 37.2517C34.3184 38.8979 36.2165 39.2804 36.2165 39.2804C36.2165 39.2804 34.6448 39.5275 34.6215 41.6309C34.6215 41.6309 34.6215 43.6549 36.2305 43.6549",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6558 30.0508L36.2227 30.1534",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4569 34.8166L36.2402 34.7793",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.308 39.3593L36.2227 39.2754",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6542 42.4954C46.527 43.3311 46.1936 44.1631 45.6403 44.9064C45.0869 45.6497 44.337 46.2497 43.5403 46.6089",
    stroke: "white",
    strokeWidth: 0.708274,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0148 42.8277C48.8304 44.0385 48.3474 45.244 47.5457 46.3209C46.744 47.3978 45.6575 48.2672 44.5033 48.7876",
    stroke: "white",
    strokeWidth: 0.708274,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAgree);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/agree.134c9130beee5230266efc50402ecb94.svg";